import { Col, Row } from "reactstrap";
import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import RestaurantMenuOutlinedIcon from "@mui/icons-material/RestaurantMenuOutlined";
import { useDispatch, useSelector } from "react-redux";
import AppModal from "../../Common/AppModal";
import {
  foodPreOrderEventPdfTableTentCards,
  foodPreOrderEventPdfTableTentCardsSuccess,
} from "../../../store/foodPreOederEvent/action";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { PdfToFile } from "../../Common/pdfToFile";

export default function WarnCustomerOfMenuChoice({
  modal,
  setModal,
  toggle,
  eventId,
  clickCallBack,
}) {
  const dispatch = useDispatch();
  const initialData = {
    Id: eventId,
    PrintOffsetLabelQty: "0",
    MasterPrintPaperType: "1",
    PrintSample: "0",
  };
  const [tableTentCardData, setTableTentCardData] = useState(initialData);

  const handleDownloadGuestTableTent = () => {
    dispatch(foodPreOrderEventPdfTableTentCards([tableTentCardData]));
  };

  const { foodPreOrderEventPdfTableTentCardsAPI } = useSelector((state) => ({
    foodPreOrderEventPdfTableTentCardsAPI:
      state.FoodPreOrderEventReducer.foodPreOrderEventPdfTableTentCards,
  }));

  useEffect(() => {
    if (isEmpty(foodPreOrderEventPdfTableTentCardsAPI)) return;
    if (foodPreOrderEventPdfTableTentCardsAPI.status === 200) {
      toast.success(foodPreOrderEventPdfTableTentCardsAPI?.message);
      const file = PdfToFile(
        foodPreOrderEventPdfTableTentCardsAPI?.PdfBase64,
        "Cards"
      );
      // download file
      const link = document.createElement("a");
      link.href = file ? URL.createObjectURL(file) : "";
      link.download = file ? "Table Tent " + file?.name : "";
      link.click();
      setModal(false);
    } else {
      toast.error(foodPreOrderEventPdfTableTentCardsAPI?.message);
    }
    dispatch(foodPreOrderEventPdfTableTentCardsSuccess([]));
  }, [foodPreOrderEventPdfTableTentCardsAPI]);
  return (
    <AppModal
      open={modal}
      onClose={toggle}
      title="Switching menus?"
      icon={<RestaurantMenuOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      footer={
        <>
          <Button color="error" onClick={() => setModal(false)}>
            Keep current menu choices
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={() => clickCallBack()}
          >
            Continue &amp; swap menu
          </Button>
        </>
      }
    >
      <Row className="g-3">
        <Col lg={12}>
          <div>
            <h5 htmlFor="name-field" className="form-label text-center">
              Switching menus?
            </h5>
            <p className={"text-center"}>
              You have already made menu selections from the current menu. These
              selections will be removed when you swap menus as you can only
              select items from one menu.
            </p>
          </div>
        </Col>
      </Row>
    </AppModal>
  );
}
